"use client";
import React, { useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";
import Link from "next/link";
import Image from "next/image";
import Logo from "../../assets/SalonTym_Logo.png";
import BeautyFace from "../../assets/beauty-face.png";
import BeautyFace2 from "../../assets/beauty-face-2-.png";
import { Box, Grid, IconButton } from "@mui/material";
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Apple,
  Android,
} from "@mui/icons-material";
import { Loader } from "../genericComponents/MainLoader/Loader";
import { usePathname } from "next/navigation";
import { FooterCityList } from "./FooterCityList";
import "./index.css";

const Footer = () => {
  const [loading, setLoading] = useState(false);
  const pathName = usePathname();

  const handleLoader = () => {
    setLoading(true);
  };
  const blankFunction = () => {};

  const handleEmailClick = () => {
    window.location.href = "mailto:info@salontym.com";
  };

  return (
    <Box>
      {loading && <Loader />}
      <footer
        style={{
          background: "#151414",
          position: "relative",
        }}
      >
        {/* <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
          }}
        >
          <Image
            src={BeautyFace2}
            alt="BeautyFace2"
            style={{
              width: "150px",
              height: "auto",
            }}
            height={500}
            width={200}
          />
        </Box> */}
        {/* <Box
          sx={{
            position: "absolute",
            left: 0,
            bottom: "65px",
          }}
        >
          <Image
            src={BeautyFace}
            alt="BeautyFace"
            style={{
              width: "150px",
              height: "auto",
            }}
            height={500}
            width={200}
          />
        </Box> */}
        <Grid container item xs={11} sm={10} md={9.5} lg={9.5} margin="auto">
          <Box
            sx={{
              zIndex: 100,
            }}
          >
            <Box
              sx={{ padding: "1.5rem 0px", borderBottom: "1px solid #373636" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  margin: "auto",
                }}
              >
                <Grid container item xs={12} sm={12} md={12} lg={12}>
                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box sx={{ margin: "1rem 0px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <LocationOnIcon
                          sx={{
                            color: "#FFBF00",
                            fontSize: "35px",
                          }}
                        />
                        <Box className="cta-text">
                          <h4>Find us</h4>
                          <span>B-23, Sector-64, Noida, India</span>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box sx={{ margin: "1rem 0px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <LocalPhoneIcon
                          sx={{
                            color: "#FFBF00",
                            fontSize: "35px",
                          }}
                        />
                        <Box className="cta-text">
                          <h4>Call us</h4>
                          <span>8510000223</span>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box sx={{ margin: "1rem 0px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <EmailIcon
                          sx={{
                            color: "#FFBF00",
                            fontSize: "35px",
                          }}
                        />
                        <Box className="cta-text">
                          <h4>Mail us</h4>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={handleEmailClick}
                          >
                            info@salontym.com
                          </span>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box
              className="footer-content pt-5 pb-5"
              sx={{
                position: "relative",
                zIndex: 2,
                borderBottom: "1px solid #373636",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                <Grid container item xs={12} sm={12} md={12} lg={12}>
                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box>
                      <Box className="footer-widget">
                        <Box className="footer-logo">
                          <Link
                            prefetch={false}
                            href={"/"}
                            style={{ textDecoration: "none", color: "inherit" }}
                            onClick={
                              pathName !== "/" ? handleLoader : blankFunction
                            }
                          >
                            <Image
                              src={Logo}
                              alt="Logo"
                              style={{
                                width: "250px",
                                cursor: "pointer",
                                height: "auto",
                              }}
                              height={500}
                              width={300}
                              loading="lazy"
                            />
                          </Link>
                        </Box>
                        <Box
                          className="footer-text"
                          sx={{ paddingRight: "1rem" }}
                        >
                          <p>
                            We are SalonTym Provides you best beauty services at
                            your door step.
                          </p>
                        </Box>
                        <Box className="footer-social-icon">
                          <span>Follow us</span>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://www.facebook.com/salontym/"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <Facebook />
                          </IconButton>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://x.com/salontym"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <Twitter />
                          </IconButton>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://www.instagram.com/salon_tym/"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <Instagram />
                          </IconButton>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://www.linkedin.com/company/salontymindia"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <LinkedIn />
                          </IconButton>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://apps.apple.com/in/app/salontym-salon-at-home/id6444617786"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <Apple />
                          </IconButton>
                          <IconButton
                            color="inherit"
                            target="_blank"
                            href="https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN"
                            sx={{
                              background: "#15741a",
                              "&:hover": {
                                background: "#15741a",
                                opacity: 0.9,
                              },
                            }}
                          >
                            <Android />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box className="mb-30">
                      <Box className="footer-widget">
                        <Box className="footer-widget-heading">
                          <h3>Useful Links</h3>
                        </Box>
                        <ul>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/"}
                              onClick={
                                pathName !== "/" ? handleLoader : blankFunction
                              }
                            >
                              Home
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/privacy-policy"}
                              onClick={
                                pathName !== "/privacy-policy"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Privacy Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              target="_blank"
                              href="https://salontym.com/blog/"
                            >
                              Blog
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/refer&earn"}
                              onClick={
                                pathName !== "/refer&earn"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Refer & Earn
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/teams"}
                              onClick={
                                pathName !== "/teams"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Teams
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/contact"}
                              onClick={
                                pathName !== "/contact"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Contact
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/store"}
                              onClick={
                                pathName !== "/store"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Store
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/contact-franchise"}
                              onClick={
                                pathName !== "/contact-franchise"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Franchise
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/register-as-a-professional"}
                              onClick={
                                pathName !== "/register-as-a-professional"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Register as a Professional
                            </Link>
                          </li>
                          <li>
                            <Link
                              prefetch={false}
                              color="inherit"
                              href={"/media"}
                              onClick={
                                pathName !== "/media"
                                  ? handleLoader
                                  : blankFunction
                              }
                            >
                              Media
                            </Link>
                          </li>
                        </ul>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid container item xs={12} sm={6} md={4} lg={4}>
                    <Box className="mb-50">
                      <Box className="footer-widget">
                        <Box className="footer-widget-heading">
                          <h3>Subscribe</h3>
                        </Box>
                        <Box className="footer-text mb-25">
                          <p>
                            Don’t miss to subscribe to our new feeds, kindly
                            fill the email below.
                          </p>
                        </Box>
                        <Box className="subscribe-form">
                          <input type="text" placeholder="Email Address" />
                          <button>
                            <TelegramIcon
                              sx={{
                                color: "#fff",
                                fontSize: "2rem",
                                transform: "rotate(-6deg)",
                              }}
                            />
                          </button>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              margin="auto"
              justifyContent="center"
              sx={{
                padding: "2rem 0rem",
              }}
            >
              <FooterCityList />
            </Grid>
          </Box>
        </Grid>
        <Box
          className="copyright-area"
          sx={{
            marginBottom: { xs: "3.5rem", sm: "0px" },
          }}
        >
          <Box>
            <Box className="text-center text-lg-left">
              <Box className="copyright-text" sx={{ textAlign: "center" }}>
                <p>
                  Copyright &copy; 2024, All Right Reserved{" "}
                  <a href="https://salontym.com">
                    ThinkAI Innovation Pvt. Ltd.
                  </a>
                </p>
              </Box>
            </Box>
          </Box>
        </Box>
      </footer>
    </Box>
  );
};

export default Footer;
